import { getAllCustomerMenuBadgeCount } from '@/api/customer/AllCustomers'
import { clearRoutePathCache } from '@/utils/routeAccess'

const state = {
  menuList: [],
  menus: [],
  routers: [],
  buttonPermissionIds: [],  // 按钮权限数组
  defaultRoutePath: '',
  customerMenuBadgeCounts: {}
}

const mutations = {
  SET_MENU_LIST: (state, list) => { state.menuList = list },
  SET_MENUS: (state, menus) => { state.menus = menus },
  SET_ROUTERS: (state, routers) => {
    state.routers = routers
    clearRoutePathCache()
  },
  // ✅ 正确赋值
  SET_BUTTON_PERMISSION_IDS: (state, ids) => {
    state.buttonPermissionIds = ids
  },
  SET_DEFAULT_ROUTE_PATH: (state, path) => {
    state.defaultRoutePath = path
  },
  SET_CUSTOMER_MENU_BADGE_COUNTS: (state, badgeCounts) => {
    state.customerMenuBadgeCounts = badgeCounts || {}
  }
}

const actions = {
  // ✅ 正确解构
  saveMenuData({ commit }, data) {
    const { menuList, menus, routers, buttonPermissionIds } = data
    commit('SET_MENU_LIST', menuList)
    commit('SET_MENUS', menus)
    commit('SET_ROUTERS', routers)
    // ✅ 正确提交
    commit('SET_BUTTON_PERMISSION_IDS', buttonPermissionIds)
    if (data.defaultRoutePath) {
      commit('SET_DEFAULT_ROUTE_PATH', data.defaultRoutePath)
    }
  },
  fetchCustomerMenuBadgeCounts({ commit }) {
    return getAllCustomerMenuBadgeCount().then(res => {
      if (res.code === '20001') {
        commit('SET_CUSTOMER_MENU_BADGE_COUNTS', res.data || {})
      }
      return res
    }).catch(err => {
      console.error('获取菜单角标失败', err)
      return Promise.reject(err)
    })
  }
}

const getters = {
  getMenuList: state => state.menuList,
  getMenus: state => state.menus,
  getRouters: state => state.routers,
  // ✅ 按钮权限 getter
  buttonPermissionIds: state => state.buttonPermissionIds || [],
  defaultRoutePath: state => state.defaultRoutePath,
  customerMenuBadgeCounts: state => state.customerMenuBadgeCounts || {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
